<template>
  <ul class="user-list">
    <li
      v-for="(user) in list"
      :key="user.uid"
      :class="user.uid === userId ? 'selected' : ''"
      @click="handlerSelectUser(user.uid)"
    >
      <el-badge
        :value="user.unread"
        :hidden="!user.unread"
        :max="99"
        :class="user.online ? 'el-icon-success' : ''"
      >
        <el-image
          :src="user['headimgurl'] || ''"
          style="width: 40px; height: 40px;"
        />
        <p>
          {{ user['nickname'] }}<br />
          {{ user.uid }}
        </p>
        <span :class="!user.manual ? 'el-icon-check' : 'el-icon-close'"></span>
      </el-badge>
    </li>
  </ul>
</template>
<script>

  import { concat, sortBy } from 'lodash'

  export default {
    name: 'LiOnlineUserList',
    props: {
      userId: {
        type: Number,
        default: 0
      },
      userList: {
        type: Array,
        default: () => []
      },
    },
    data: function () {
      return {}
    },
    computed: {
      list: function () {
        const online = this.userList.filter(user => user.online)
        let offline = this.userList.filter(user => !user.online)
        offline = sortBy(offline, u => u.last_say).reverse()

        return concat(online, offline)
      }
    },
    methods: {
      handlerSelectUser: function (uid) {
        this.$emit('input', uid)
      }
    }
  }
</script>
<style>
  .user-list {
    list-style: none;
    text-align: left;
    padding: 0;
  }
  .user-list li {
    cursor:pointer;
    margin: 5px 0 0;
    padding: 1px;
  }
  .user-list li.selected {
    background: #CCC;
  }
  .user-list li p {
    padding: 0 0 0 5px;
    margin: 0;
    display: inline-block;
  }
</style>